import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import selectDownArrow from "../../../assets/images/selectDownArrow.svg"; // Adjust this path as needed

const SharedCountryDropdown = ({
  label = "Country",
  placeholder = "Select Country",
  selectedCountry,
  setSelectedCountry,
  disabled = false,
  onCountryChange = () => {},
}) => {
  const [countryOptions, setCountryOptions] = useState([]);
  const [countrySearch, setCountrySearch] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fetch country data
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          "https://restcountries.com/v3.1/all?fields=name,cca2,currencies"
        );
        const data = await response.json();

        if (Array.isArray(data)) {
          const sortedCountries = data
            .sort((a, b) => a.name.common.localeCompare(b.name.common))
            .map((item) => {
              const currencyCode = item.currencies
                ? Object.keys(item.currencies)[0]
                : "";
              const currencyName = currencyCode
                ? item.currencies[currencyCode]?.name
                : "";
              const currencySymbol = currencyCode
                ? item.currencies[currencyCode]?.symbol
                : "";

              return {
                label: item.name.common,
                value: item.name.common,
                code: item.cca2,
                currency: {
                  code: currencyCode,
                  name: currencyName,
                  symbol: currencySymbol,
                },
              };
            });

          setCountryOptions(sortedCountries);
        }
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // Handle country selection
  const handleCountrySelect = (selectedName) => {
    const selected = countryOptions.find((c) => c.value === selectedName);
    const currencyName = selected?.currency?.name || "";
    const currencySymbol = selected?.currency?.symbol || "";

    setSelectedCountry(selectedName);
    onCountryChange({
      name: selectedName,
      currency: currencyName ? `${currencyName} (${currencySymbol})` : "",
      currencySymbol,
      countryCode: selected?.code || "",
    });

    setCountrySearch("");
    setDropdownOpen(false);
  };

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const openDropdown = () => setDropdownOpen(true);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setCountrySearch(selectedCountry || "");
  }, [selectedCountry]);

  return (
    <Form.Group className="custom-form">
      {label && <Form.Label className="color-head">{label}</Form.Label>}

      <div
        className={`country-dropdown-wrapper ${disabled ? "disabled" : ""}`}
        ref={dropdownRef}
        aria-disabled={disabled}
      >
        <InputGroup
          className="country-search-box"
          onClick={() => {
            if (!disabled) toggleDropdown();
          }}
        >
          <Form.Control
            type="text"
            className="country-input"
            placeholder={placeholder}
            value={countrySearch}
            disabled={disabled}
            onChange={(e) => {
              const value = e.target.value;
              setCountrySearch(value);
              if (!disabled) {
                setDropdownOpen(true);
              }

              // NEW: Clear selectedCountry & formData.region when emptied
              if (value.trim() === "") {
                setSelectedCountry("");
                onCountryChange({
                  name: "",
                  currency: "",
                  currencySymbol: "",
                  countryCode: "",
                });
              }
            }}
            // onFocus={() => {
            //   if (!disabled) openDropdown();
            // }}
            aria-disabled={disabled}
          />
          <InputGroup.Text
            className="dropdown-arrow-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled) openDropdown();
            }}
            style={{
              backgroundColor: "transparent",
              border: "none",
              cursor: disabled ? "not-allowed" : "pointer",
            }}
            aria-hidden={disabled}
          >
            <img
              src={selectDownArrow}
              alt="CaretDown"
              className="dropdown-arrow"
            />
          </InputGroup.Text>
        </InputGroup>

        {dropdownOpen && (
          <div className="country-dropdown-list">
            {countryOptions
              .filter((item) =>
                item.label
                  .toLowerCase()
                  .includes(countrySearch.toLowerCase().trim())
              )
              .map((item) => (
                <div
                  key={item.value}
                  onClick={() => {
                    if (!disabled) handleCountrySelect(item.value);
                  }}
                  className={`country-option ${disabled ? "disabled" : ""}`}
                  role="button"
                  tabIndex={disabled ? -1 : 0}
                >
                  {item.label}
                </div>
              ))}
          </div>
        )}
      </div>
    </Form.Group>
  );
};

export default SharedCountryDropdown;
